import type { SummeryTranslations } from "@/service/translate/summery/SummeryTranslations.types"
import { getCgvLink } from "@/service/legalLinks/legalLinksService"

const cgvUrl = getCgvLink()

const SummeryNlTranslations: SummeryTranslations = {
    "summery": {
        "title": "Detail van mijn bestelling",
        "included": "inbegrepen",
        "confirmationSummaryDetails": "Details van mijn bestelling",
        "samePrice": "Dezelfde prijs"
    },
    "tripSummery": {
        "title": "Je reis",
        "destination": "Bestemming",
        "dates": "Data",
        "participants": "Deelnemers",
        "origin": "Vertrek vanuit",
        "package": "Pakket",
        "journey": "Reis"
    },
    "traveller": {
        "adult": "volwassene",
        "adult_plural": "volwassenen",
        "child": "kind",
        "child_plural": "kinderen"
    },
    "packageSummery": {
        "title": "Pakket",
        "hsTitle": "Uw verblijf",
        "stay": "Verblijf",
        "flight": "Vlucht",
        "train": "Trein",
        "transfers": "Transfers",
        "skiPass": "Skipas",
        "equipment": "Uitrusting",
        "accomodation": "Accommodatie details",
        "noskipass": "Skipas verwijderd uit pakket",
        "noequipment": "Uitrusting verwijderd uit pakket",
        "valleyNight": "Terug naar de vallei op zaterdagavond"
    },
    "extrasSummery": {
        "title": "Extra's",
        "titleCSE": "Uw services"
    },
    "priceSummery": {
        "fee": "Boekingskosten",
        "total": "Totaal",
        "perPerson": "Per persoon",
        "payableNow": "Nu te betalen",
        "payableLater": "Later te betalen",
        "lastMinuteDiscount": "Laatste minuten korting"
    },
    "paymentCondition": {
        "fix": "Fix",
        "flex": "Flex",
        "fixLong": "<b>De beste prijs</b>",
        "flexLong": "<b>Flexibiliteit</b>",
        "fixDescription": `Wijzigen of restitutie niet mogelijk. Volledige betaling bij boeking. Bij wijziging of annulering geen terugbetaling reissom en overige kosten (boekingskosten, SGR, Cal.fonds en verzekering), volgens <a href="${cgvUrl}" target="_blank">ANVR-reizigersvoorwaarden.</a>`,
        // "flexDescription": `Annulering of wijzigingen mogelijk tot cancellation_until, volgens  <a href="${cgvUrl}" target="_blank">ANVR-reizigersvoorwaarden.</a>`,
        "flexDescription": `30% aanbetaling bij boeking. Annuleren of wijzigen volgens de <a href="${cgvUrl}" target="_blank">ANVR- & Travelski.nl reizigersvoorwaarden.</a> `,
        // Train-only
        "trainOnlyDescription": `Annulering en wijziging volgens de <a href="${cgvUrl}" target="_blank" rel="noopener">algemene verkoopvoorwaarden</a>.`
    },
    "bestPrice": {
        "title": "Besteprijsgarantie",
        "description": "Door te boeken bij Travelski ben je verzekerd van de beste prijs."
    },
    "transferSummery": {
        "title": "Transfers",
        "description": "Privétransfer van en naar het resort",
        "funicularDescription": "Retourtransfer per kabelbaan"
    },
    "familyService": {
        "3": "Skipas",
        "4": "Hotelservices",
        "5": "Maaltijdpakket levering",
        "6": "Verzekering",
        "7": "Jouw services",
        "8": "Busreis",
        "11": "Restaurant",
        "12": "Skischool ter plaatse - groepslessen",
        "13": "Welzijn activiteiten",
        "14": "Ski-/snowboardhuur",
        "30": "Helm",
        "38": "Dutchweek-polsbandje",
        "40": "After Ski activiteiten",
        "41": "Sport",
        "42": "Pretpark",
        "44": "Lazy Sunday",
        "53": "Ski-/snowboardhuur",
        "54": "Ski-/snowboardhuur",
        "55": "Ski-/snowboardhuur",
        "56": "Ski-/snowboardhuur",
        "57": "Ski-/snowboardhuur",
        "63": "Ski-/snowboardhuur",
        "64": "NL ski/snowboardlessen of skitraining",
        "65": "Multi-activiteitenpas",
        "66": "Pretpark",
        "67": "Bagagerie",
        "68": "Test & Ride Center",
        "69": "Parkeren",
        "70": "Toeristenbelasting",
        "71": "Verkoop ter plaatse",
        "72": "Fiets activiteiten",
        "73": "Lazy Sunday | Eén extra nacht",
        "74": "Wandelen- & outdooractiviteiten",
        "75": "Familie skipas",
        "77": "First Tracks",
        "78": "Transfer",
        "81": "Vlucht",
        "82": "Bagage",
        "83": "Busreis",
        "84": "Ontbijt"

    },
    "priceUpdatedSummery": {
        "priceUpdated": "Prijs bijgewerkt op",
        "priceUpdatedDescription": "De prijs van je bestelling kan veranderen op basis van de beschikbare aanbieding van onze leveranciers."
    }
}
export default SummeryNlTranslations;